module.exports = __webpack_public_path__ + "static/media/phone.4e1be1a5.4e1be1a5.png";